<template>
  <div id="content-wrapper">
    <div class="container-fluid pb-0">
      <div class="top-mobile-search">
        <div class="row">
          <div class="col-md-12">
            <form class="mobile-search">
              <div class="input-group">
                <input type="text" placeholder="Search for..." class="form-control" />
                <div class="input-group-append">
                  <button type="button" class="btn btn-dark">
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-12">
            <div class="main-title">
              <div class="btn-group float-right right-action">
                <!-- <a class="right-action-link text-gray">See More</a> -->
              </div>
              <h6 style="text-transform: capitalize;">
                {{ $store.state.cdt[$route.params.cateory_name]
                }}
              </h6>
            </div>
          </div>
          <div class="col-xl-3 col-sm-6 mb-3" v-for="(video, i) in videoinfos" v-bind:key="i">
            <videoinfocard
              :title_text="video.title"
              :video_id="video.id"
              :image_src="video.cover"
              :duration="video.duration"
              :views="video.updated_at"
              :time_post="video.created_at"
              :category="video.category"
            ></videoinfocard>
          </div>
        </div>
      </div>

      <hr class="mt-0" />
    </div>
  </div>
</template>


<script>
import videoinfocard from "../components/videoinfocard.vue";
import BasicAPIs from "../api/apis";
export default {
  name: "PgCategory",
  components: {
    videoinfocard
  },
  props: {},
  data: function() {
    return {
      videoinfos: []
    };
  },
  mounted() {
    let vm = this;
    let c = this.$store.state.cdt[this.$route.params.cateory_name];

    BasicAPIs.getByCategory(c).then(res => {
      vm.videoinfos = res.data.data.Items;
    });
    // Action
  }
};
</script>


<style  lang='scss'>
</style>